import { fetchPostmanFHIR, useMock } from '../../postman'
import { fhirAPI } from '../fhirAPI'

// Read Patient Information
export const readPatient = async (patientId: string) => {
	try {
		let results
		const params: FhirBody = {
			url: `Patient/${patientId}`,
			method: 'GET',
			eCode: 'BP-FA-003'
		}

		if (useMock('PATIENT')) {
			results = await fetchPostmanFHIR(params)
		} else {
			results = await fhirAPI(params)
		}
		return results
	} catch (error) {
		throw error
	}
}

// Search Patient Information
export const searchPatient = async (contractId: string) => {
	try {
		let results
		const params: FhirBody = {
			url: `Patient?identifier=${contractId}`,
			method: 'GET',
			eCode: 'BP-FA-004'
		}

		if (useMock('PATIENT')) {
			results = await fetchPostmanFHIR(params)
		} else {
			results = await fhirAPI(params)
		}
		return results
	} catch (error) {
		throw error
	}
}
